<i18n>
{
  "no": {
    "header": "Gratulerer, du er nå ferdig med å konfigurere enheten din!",
    "infoMessage": "Enheten din er nå tilkoblet. Du kan nå lukke dette vinduet."
  },
  "en": {
    "header": "Congratulations, you are now finished with setting up your device!",
    "infoMessage": "Your device is now connected. You may now close this window."
  }
}
</i18n>

<template>
  <div class="page">
    <FormWrapper>
      <div class="text-center">
        <img :src="successImage" alt="" aria-hidden="true" class="margin-top-3xl result-image" />

        <!-- Was a native <header size="l">, which rendered unstyled. -->
        <TnHeading type="h1" size="s" align="center" class="margin-vertical-2xl">
          {{ t('header') }}
        </TnHeading>

        <TnParagraph size="s">{{ t('infoMessage') }}</TnParagraph>
      </div>
    </FormWrapper>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { TnHeading, TnParagraph } from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from '@/components/FormWrapper.vue';
import successImage from '@/assets/device_success.svg';

const { t } = useI18n();
</script>

<style scoped>
.result-image {
  display: block;
  width: 100px;
  height: 100px;
  margin-inline: auto;
}
</style>
